<main class="landing-shell" [class.is-rtl]="preferences.direction() === 'rtl'">
  <app-landing-header />
  <app-hero-section />
  <app-features-section #featuresSection />
  <app-steps-section />
  <app-support-card />

  <div #ctaWrap class="cta-wrap">
    <button class="primary-cta" type="button" routerLink="/personal-fund-request/personal-data">
      {{ preferences.t('landing.cta') }}
    </button>
  </div>
</main>

@if (showStickyCta) {
  <div class="sticky-cta-wrap">
    <button class="primary-cta sticky-cta" type="button" routerLink="/personal-fund-request/personal-data">
      {{ preferences.t('landing.cta') }}
    </button>
  </div>
}
